import * as types from '../types.js';
import api from '../api.js';
import db from '../../versa/db.js';

function parseIdList(raw)
{
	if (raw == null || String(raw).trim() === '')
		return null;
	const ids = String(raw)
		.split(/[,;\s]+/)
		.map(s => s.trim())
		.filter(Boolean)
		.map(s => parseInt(s, 10))
		.filter(n => !Number.isNaN(n) && n >= 1);
	return ids.length ? ids : null;
}

/**
 * @param {string} companyId UUID da empresa (tenant) — vem do filtro da grade, não do formulário.
 */
export default function buildReplenishmentGeneratorForm(companyId)
{
	return {

		html: `
			<style>
				#replenishment #company_id		{ display: none; }
				#replenishment #warehouse_id	{ width: 16rem; }
				#replenishment #location_ids,
				#replenishment #product_ids,
				#replenishment #class_ids		{ width: 100%; max-width: 36rem; }
				#replenishment .hint				{ font-size: 0.85rem; opacity: 0.85; margin: 0.2rem 0 0; }
			</style>
			<form id="replenishment" class="form" autocomplete="off">
				<input type="hidden" id="company_id" name="company_id">
				<datalist id="warehouses">
				</datalist>
				<datalist id="classes">
				</datalist>
				<div class="title">
					Gerar Novo Ressuprimento
				</div>
				<div class="mtl fsb">
					<label title="Armazém">Armazém<sup>*</sup>
						<input id="warehouse_id" type="text" list="warehouses" required>
					</label>
				</div>
				<div class="mtm">
					<label title="Limitar a posições (IDs, separados por vírgula)">Posições (opcional)
						<input id="location_ids" type="text" placeholder="ex.: 101, 102">
					</label>
					<p class="hint">Filtra regras apenas nas posições indicadas.</p>
				</div>
				<div class="mtm">
					<label title="Limitar a produtos (IDs)">Produtos (opcional)
						<input id="product_ids" type="text" placeholder="ex.: 5001, 5002">
					</label>
				</div>
				<div class="mtm">
					<label title="Limitar a produtos que possuam alguma destas classes (IDs)">Classes (opcional)
						<input id="class_ids" type="text" list="classes" placeholder="ex.: 1, 2">
					</label>
				</div>
				<div class="mtm">
					<button class='bn_Escape button'>Cancelar</button>
					<button class='bn_Enter button'>Gerar</button>
				</div>
			</form>
		`,

		form:
		{
			selector: '#replenishment',
			submitHandler(formset, ev)
			{
				ev?.preventDefault();
				formset.form.syncFromDom();
				const v = formset.form.getValues();
				if (!v.company_id)
					throw new Error('Empresa (tenant) não definida — use o filtro da grade.');
				if (!v.warehouse_id)
					throw new Error('Verificar Armazém*');
				const body = {};
				const loc = parseIdList(v.location_ids);
				const prod = parseIdList(v.product_ids);
				const cls = parseIdList(v.class_ids);
				if (loc)
					body.location_ids = loc;
				if (prod)
					body.product_ids = prod;
				if (cls)
					body.class_ids = cls;
				formset.callback?.call(formset, {
					company_id: v.company_id,
					warehouse_id: v.warehouse_id,
					_payload: body,
				});
			},
			init(formset)
			{
				formset.form.eraseValues();
				const cidEl = document.querySelector('#replenishment #company_id');
				if (cidEl)
					cidEl.value = companyId;
				Object.getPrototypeOf(this).init.call(this);
				const q = '?limit=0&filter=' + encodeURIComponent(`company_id*eq*${companyId}`);
				api.call(api.list_classes, q).then((data) =>
				{
					if (data && data.length)
						db.set('classes', data);
					return formset.loadList('#classes', 'classes', { labels: ['name'] });
				}).catch(() => {});
			},
		},

		fields: [
			{ properties: { selector: '#company_id' }, types: [types.pubsub()] },
			{ properties: { selector: '#warehouse_id' }, types: [types.pubsub(), types.datalist(), types.observer('company_id'), types.obs_load_options('warehouses')] },
			{ properties: { selector: '#location_ids' }, types: [types.pubsub()] },
			{ properties: { selector: '#product_ids' }, types: [types.pubsub()] },
			{ properties: { selector: '#class_ids' }, types: [types.pubsub(), types.datalist()] },
		],

	};

}
